import { useGridApiRef } from '@mui/x-data-grid';
import { type MRT_ColumnDef } from 'mantine-react-table';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { openReportAPIRefSliceAction } from '../../../../../app/Slices/ReportAPIRefSlice';
import { CustomChip } from '../../../../../layout/styledcomponents/CustomChip';
import GenericTable from '../../../../shared/GenericTable';

type RowType = {
    firstName: string;
    email: string;
    phone: string;
    isActive: boolean;
    bookings: number;
};

export default function BookerDetailsReportList(params: any) {
    const apiRef = useGridApiRef();
    const dispatch = useDispatch();

    useEffect(() => {
        const csv = apiRef?.current.exportDataAsCsv;
        const print = apiRef?.current.exportDataAsPrint;
        dispatch(
            openReportAPIRefSliceAction({
                exportInfo: {
                    csvExport: csv,
                    printExport: print,
                },
            }),
        );
    }, [apiRef]);

    const columns: MRT_ColumnDef<RowType>[] = [
        {
            accessorKey: 'firstName',
            header: 'Staff',
        },
        {
            accessorKey: 'email',
            header: 'Email',
        },
        {
            accessorKey: 'phone',
            header: 'Phone',
            id: 'phone',
        },
        {
            accessorKey: 'isActive',
            id: 'isActive',
            header: 'Status',
            filterVariant: 'select',
            filterFn: (row, _columnId, filterValue) => {
                if (filterValue === '') return true; // no filter applied
                return String(row.getValue('isActive')) === filterValue;
            },

            mantineFilterSelectProps: {
                data: [
                    { label: 'Enabled', value: 'true' },
                    { label: 'Disabled', value: 'false' },
                ],
                clearable: true,
            },
            mantineTableHeadCellProps: {
                title: 'Users Access',
            },
            Cell: ({ row, cell }) => {
                const status = cell.getValue();

                return (
                    <CustomChip
                        label={status === true ? 'Enabled' : 'Disabled'}
                        color={status === true ? 'green' : 'warning'}
                        variant='outlined'
                    />
                );
            },
        },

        {
            accessorKey: 'bookings',
            header: 'Completed Reservations',
            mantineTableHeadCellProps: {
                title: 'No. of successfully completed reservations to date',
            },
        },
    ];

    return (
        <GenericTable
            columns={columns}
            data={params.data ?? []}
            tableName='Booker-Details-Report'
            loading={false}
        />
    );
}
